export const OrderList = ({ children }) => {
  const listStyle = {
    marginBlockStart: '0px',
    paddingInlineStart: '0px',
  };

  return <ol style={listStyle}>{children}</ol>;
};
